/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Import_Token_RequiredInputs */

const cs_import_token_required = /** @type {(inputs: Import_Token_RequiredInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Přihlaste se nebo vložte IT token pro import.`)
};

const en_import_token_required = /** @type {(inputs: Import_Token_RequiredInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sign in or paste an IT import token.`)
};

/**
* | output |
* | --- |
* | "Sign in or paste an IT import token." |
*
* @param {Import_Token_RequiredInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const import_token_required = /** @type {((inputs?: Import_Token_RequiredInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Import_Token_RequiredInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_import_token_required(inputs)
	return cs_import_token_required(inputs)
});